<div class="modal-column">
  <div class="modal-container">
    <div class="jackpot-keys">
      <div>
        <div class="participants-label-wrap">
          <img src="/assets/images/v2/jackpot/key-only.svg" width="40" alt="" class="key-icon">
          <h5 class="no-margin">Your jackpot keys ({{ keyCount }})</h5>
        </div>
        <div class="keys-wrap">
          <div class="jackpot-key-row" *ngFor="let key of info">
            <div class="jackpot-key-icon"></div>
            <div class="jackpot-key-label">
              <div class="ui-text-small">{{ key._id }}</div>
              <div class="jackpot-key-date">{{ key.createdAt | date : 'short' }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <a [routerLink]="['/', {outlets: { modal: null } } ]" class="icon close-popup">
    <i class="fal fa-times"></i>
  </a>
</div>



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/_v2/template/modals/jackpot-keys/jackpot-keys-modal.template.html